module.exports = "../images/provide-fishing-2.jpg?v=0c645e2";